module.exports = __webpack_public_path__ + "static/media/SingaporeColored.611367e9.svg";